// removed by extract-text-webpack-plugin
module.exports = {"app__loader":"jXVdiQCTPnM7SPtHc1K5G_0","loader__spinner":"_1fHPxmeqQIKQCFOJAzqn2U_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06511ed7","scoped":false,"hasInlineConfig":false}!./~/stylus-loader?{"sourceMap":true}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/AppLoader.vue
// module id = skZa
// module chunks = 1